import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getStoreSettings } from '../api/waiting.api';
import Layout from '../components/layout/Layout';
import TakeoutMenuManager from '../components/settings/TakeoutMenuManager';
import styles from './SettingsPage.module.css';

export default function MenuSettingsPage() {
  const { storeId, isDemo } = useAuth();
  const [takeoutEnabled, setTakeoutEnabled] = useState<boolean | null>(isDemo ? true : null);
  const [isLoading, setIsLoading] = useState(!isDemo);

  const loadSettings = useCallback(async () => {
    if (!storeId) return;
    if (isDemo) {
      setTakeoutEnabled(true);
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const settings = await getStoreSettings(storeId);
      setTakeoutEnabled(Boolean(settings.takeoutEnabled));
    } catch {
      setTakeoutEnabled(false);
    } finally {
      setIsLoading(false);
    }
  }, [storeId, isDemo]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  return (
    <Layout title="메뉴 설정">
      <div className={styles.page}>
        {isLoading ? (
          <div className={styles.loadingText}>로딩 중...</div>
        ) : takeoutEnabled ? (
          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>포장 메뉴 관리</h2>
            {storeId && <TakeoutMenuManager storeId={storeId} />}
          </div>
        ) : (
          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>포장 기능이 꺼져 있습니다</h2>
            <p style={{ color: '#64748b', marginBottom: '16px', lineHeight: 1.6 }}>
              메뉴 설정은 포장 주문 기능이 활성화된 경우에만 사용할 수 있습니다.<br />
              매장 설정 페이지에서 포장 기능을 먼저 켜주세요.
            </p>
            <Link to="/settings/store" className={styles.saveButton} style={{ textDecoration: 'none', display: 'inline-block' }}>
              매장 설정으로 이동
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
}
